import React from 'react';
import useIsLandscape from '../../javascript/utils/use-is-landscape.js';
import style from './page-wrap.module.scss';

function PageWrap(Props) {
  const isLandscape = useIsLandscape();

  return (
    <div className={style.wrapper} data-orientation={isLandscape ? 'landscape' : 'portrait'}>
         {Props.children}
   </div>
  );
}
export default PageWrap;